import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectedValue,BreadCrumbData, Relation, ActionState } from '../shared/model';
//import { Subscription } from 'rxjs';
import { ComponentConfig } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { BreadCrumbsService } from './bread-crumbs.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ubs-title-bread-crumbs',
  templateUrl: './title-bread-crumbs.component.html',
  styleUrls: ['./title-bread-crumbs.component.scss']
})
export class TitleBreadCrumbsComponent implements OnInit,OnChanges {
  /**
   * The componentConfig object
   * ToDo: Remove because it't not used
   */
  @Input() componentConfig:ComponentConfig;
  /**
   * The currently selected breadCrums
   */
  @Input() activeBreadCrumb:BreadCrumbData;
  /**
   * List containing related objects
   * Only used when the action is set to "edit"
   * 
   */
  @Input() relations:Relation[];
  /**
   * Selected Value coming in from a hyperlink or a deeplink
   */
  @Input() selectedValue:SelectedValue;
  /**
   * The currently selected relation
   */
  selectedRelation:Relation;
  /**
   * The breadCrumb data from the component store
   */
  breadCrumbs:BreadCrumbData[];
  /**
   * The breadCrumbData as clickable links
   */
  breadCrumbLinks:any[];
  /**
   * number of links 
   */
  numberOfLinks:number;
  /**
   * Position in the tree
   */
  level:number;
  /**
   * Whether the current is "edit" not - default is false
   */
  edit:boolean = false;
  /**
   * Whether the current action is "list" or not - default is true
   */
  list:boolean = true;
  /**
   * Extra label text for use in add view
   */
  addText:string;
  /**
   * Extra label text for use in edit view
   */
  editText:string;
  /**
   * The current action
   */
  activeAction:String;

  inactiveBreadCrumbElement:ElementRef;
  /**
   * Whether there is a context menu in the context
   */
  hasContextMenu = false;
  /**
   * menuItems for context menu
   */
  items:NbMenuItem[] = [];
  
  title:string;

  private destroy$ = new Subject<void>();
  /**
   *  Emits the selected bread crumb on click
   */  
  @Output() selectedBreadCrumb = new EventEmitter();
  @Output() createView = new EventEmitter();
  @Output() setAction = new EventEmitter();

  @ViewChild('editBreadCrumb',{static:false}) editBreadCrumb:ElementRef;
  @ViewChild('createBreadCrumb',{static:false}) createBreadCrumb:ElementRef
  
  constructor(
    private componentStoreService:UbsComponentStoreService,
    private router: Router, 
    private route: ActivatedRoute,
    private renderer: Renderer2) {}

  ngOnInit(): void {
    console.log({TrackBreadCrumbs:{ActiveBreadCrumbOnInit:this.activeBreadCrumb}});
    this.componentStoreService.breadCrumbs$.subscribe((breadCrumbData:BreadCrumbData[]) => {
      if(breadCrumbData != undefined){
        this.breadCrumbs = breadCrumbData;
        this.numberOfLinks = breadCrumbData.length;
        if(this.activeBreadCrumb != undefined){
          this.makeBreadCrumbLink(this.activeBreadCrumb,this.breadCrumbs);
        }
        console.log({TrackBreadCrumbs:{breadCrumbs:this.breadCrumbs,numberOfLinks:this.numberOfLinks}});
      }else{
        this.componentStoreService.componentConfig$.subscribe(data => {
          this.makeRouteBreadCrumb();
        })
      }
    });
    this.componentStoreService.action$
    .subscribe(data => {
      this.activeAction = data;
      console.log({TrackAction:{activeAction:this.activeAction}});
      //console.log("action in TitleBreadCrumbsComponent",data);
      switch (data) {
        case "edit":
        case "relate":
          this.activeAction = "edit";
          if(this.activeBreadCrumb){
            this.editText = this.activeBreadCrumb.editFormText;
          }else{
            this.route.data.subscribe(data => {
              if(data["type"] != undefined){
                this.editText = data["type"];
              }
            });
          }
          
          if(this.relations != undefined && this.relations.length > 0){
            this.hasContextMenu = true;
          }
          if(data == "relate"){
            let currentClassList:DOMTokenList = this.editBreadCrumb.nativeElement.classList;
            console.log({CurrentClassList:currentClassList});
            this.renderer.removeClass(this.editBreadCrumb.nativeElement,"disabled");
            this.renderer.addClass(this.editBreadCrumb.nativeElement,"inactive");
            this.renderer.removeClass(this.editBreadCrumb.nativeElement,"active");
          }
          console.log({TrackBreadCrumbs:{editText:this.editText}});
          break;
        case "list":
          this.activeAction = "list";
          //this.hasContextMenu = false;
          if(this.createBreadCrumb){
            let currentClassList:DOMTokenList = this.createBreadCrumb.nativeElement.classList;
            if(currentClassList.contains("disabled") && currentClassList.contains("active")){
              this.renderer.addClass(this.createBreadCrumb.nativeElement,"inactive");
              this.renderer.removeClass(this.createBreadCrumb.nativeElement,"active");
              this.renderer.removeClass(this.createBreadCrumb.nativeElement,"disabled");
            }
          }
          break;      
        default:
          break;
      }

    });
    /* this.menuService.onItemClick()
    .pipe(takeUntil(this.destroy$))
    .subscribe((menuBag) => {
      if(menuBag.tag == "contextMenu"){
        this.selectedRelation = this.relations.find((relation:Relation) => relation.title == menuBag.item.title);
        this.componentStoreService.updateSelectedRelation(this.selectedRelation);
        this.componentStoreService.updateAction(ActionState.RELATE);
      }      
    }) */
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["activeBreadCrumb"]){
      console.log({TrackBreadCrumbs:{ActiveBreadCrumbOnChanges:this.activeBreadCrumb}});
      this.level = this.activeBreadCrumb? this.activeBreadCrumb.level : 1;
      if(this.breadCrumbs){
        this.makeBreadCrumbLink(this.activeBreadCrumb,this.breadCrumbs);
      }else{
        //Try subscribe again to the store
        this.componentStoreService.breadCrumbs$.subscribe((breadCrumbData:BreadCrumbData[]) => {
          if(breadCrumbData && this.activeBreadCrumb != undefined){
            this.breadCrumbs = breadCrumbData;
            this.makeBreadCrumbLink(this.activeBreadCrumb,this.breadCrumbs);
          }
        });
      }
      if(this.activeBreadCrumb){
        this.addText = this.activeBreadCrumb.addFormText;
        this.editText = this.activeBreadCrumb.editFormText;
        
      }
      
    }
    if(changes["relations"]){
      console.log({TrackRelations:{component:"TitleBreadCrumbsComponent",value:this.relations}})
      if(this.relations != undefined && this.relations.length > 0){
        
        this.hasContextMenu = true;
        this.relations.forEach(relation => {
          let menuItem:NbMenuItem = {"title":relation.title};
          this.items.push(menuItem);
        });
      }
      
    }
  }
  /**
   * 
   * @param breadCrumb - Active breadCrumb of type BreadCrumb
   * @param breadCrumbs - List of breadCrumbs for this component
   */
  makeBreadCrumbLink(breadCrumb:BreadCrumbData,breadCrumbs:BreadCrumbData[]):void{
    this.breadCrumbLinks = [];
    let level = breadCrumb.level;
    for (let i = 0; i < breadCrumbs.length; i++) {
      let breadCrumbLink = {};
      breadCrumbLink["displayText"] = this.setbreadCrumbLinkDisplayName(breadCrumbs[i]);
      breadCrumbLink["selectedValue"] = breadCrumbs[i].selectedValue;
      breadCrumbLink["level"] = i+1;
      //this.breadCrumbs[i].display
      if (i+1 === level && this.activeAction == "list" || this.activeAction == undefined) {
        breadCrumbLink["selected"] = "selected"
        breadCrumbLink["state"] = "inactive";
      }else{
        breadCrumbLink["state"] = "active";
      }
      this.breadCrumbLinks.push(breadCrumbLink);
      if (i+1 === level) {
        break;
      }
    }
    console.log({TrackBreadCrumbs:{MakeBreadCrumbLink:this.breadCrumbLinks,"action":this.activeAction}})
    
  }

  setbreadCrumbLinkDisplayName(breadCrumb:BreadCrumbData):string{
    let displayText = "";
    if(breadCrumb.displayPrefix){
      displayText = displayText+breadCrumb.displayPrefix;
    }
    if(breadCrumb.label){
      console.log({label:breadCrumb.label});
      displayText = displayText+""+breadCrumb.label;
    }
    if(breadCrumb.displayPostfix){
      displayText = displayText+""+breadCrumb.displayPostfix;
    }
    
    return displayText;
  }

  breadCrumbLinkSelected(level:number){
    console.log("Link selected",level);
    let selectedBreadCrumb = this.breadCrumbs.find(element => element.level == level);
    if(selectedBreadCrumb){
      console.log("selectedBreadCrumb",selectedBreadCrumb);
      this.selectedBreadCrumb.emit(selectedBreadCrumb);
    }
  }

  loadCreate(level:number){
    console.log("Load Create Clicked - level emitted: ",level);
    this.activeAction = "add";
    this.renderer.removeClass(this.createBreadCrumb.nativeElement,"inactive");
    this.renderer.addClass(this.createBreadCrumb.nativeElement,"active");
    this.renderer.addClass(this.createBreadCrumb.nativeElement,"disabled");
    this.componentStoreService.updateSelectedValue(null);
    this.componentStoreService.updateAction(ActionState.ADD);
    this.createView.emit(level);
  }
  /**
   * Don't think this one is called from anywhere 
   * */
  toggleCreate():void{
    console.log("Toggling create ...");
    let currentClassList:DOMTokenList = this.createBreadCrumb.nativeElement.classList;
    console.log({classList:currentClassList});
    currentClassList.forEach(className => {
      if(className === "inactive"){
        this.setActive(this.createBreadCrumb.nativeElement,"toActive")
      }
      if(className === "active"){
        console.log("Found active ... className: "+className);
        this.setActive(this.createBreadCrumb.nativeElement,"toInactive")
      }
    })
    
  }
  setEdit(){
    this.setAction.emit("edit");
  }
  /**
   * Not called ..delete
   * @param element Don
   * @param toState 
   */
  setActive(element:ElementRef,toState:string):void{
    switch (toState) {
      case "toActive":
        console.log("Setting Element to Active")
        this.renderer.removeClass(element,"inactive");
        this.renderer.addClass(element,"active");
        this.renderer.addClass(element,"disabled");
        break;
      case "toInactive":
        console.log("Setting element to Inactive")
        this.renderer.addClass(element,"inactive");
        this.renderer.removeClass(element,"active");
        this.renderer.removeClass(element,"disabled");
        break;
    
      default:
        break;
    }
  }

  makeRouteBreadCrumb(){
    this.router.events.subscribe(() => {
      this.breadCrumbs = this.createBreadcrumbs(this.route.root);
      this.title = this.breadCrumbs[this.breadCrumbs.length -1].label;
    });
  }

  createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Array<{ label: string; url: string }> = []): Array<{ label: string; url: string }> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeConfig = child.routeConfig;
      if (!routeConfig || !routeConfig.path) {
        continue;
      }

      const segment = routeConfig.path;
      let label;
      url += `/${segment}`;
      if(segment.includes(":")){
        try{
          let paramKey = routeConfig.data["paramKey"];
          if(paramKey){
            this.route.params.subscribe(params => {
              label = routeConfig.data?.['breadcrumb']+params[paramKey]
            })
          }
        }catch{
          console.error("No paramKey or data object in route configuration")
        }
      }
      if(label == undefined){
        label = routeConfig.data?.['breadcrumb'] || segment;
      }

      breadcrumbs.push({ label, url });

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

/* 
@Component({
  selector: 'app-breadcrumb',
  template: `
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let crumb of breadcrumbs; let last = last">
          <a *ngIf="!last; else lastBreadcrumb" [routerLink]="crumb.url">{{ crumb.label }}</a>
          <ng-template #lastBreadcrumb>{{ crumb.label }}</ng-template>
        </li>
      </ol>
    </nav>
  `,
  styles: [`
    .breadcrumb {
      padding: 0.5rem 1rem;
      background-color: #f8f9fa;
      margin-bottom: 1rem;
    }
  `]
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Array<{ label: string; url: string }> = [];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.breadcrumbs = this.createBreadcrumbs(this.route.root);
    });
  }

  
} */

